import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router";
import { UrlPath } from "../../../config/routeConfig";
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsMenuList } from "../../actions/assetTransactionsAction";

export const HoverList = ({ isHovered, handleListMouseEnter, handleListMouseLeave }) => {

  const history = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();

  const Gstate =
  useSelector((state) => {
    return state;
  }) || {};
  const TransactionMenuList = Gstate.transactionList.transactionMenuList || [];

  useEffect(() => {
    if(isHovered === true)
    dispatch(getTransactionsMenuList(1));
  },[isHovered]);

  const handleItemClick = (item) => {
    const transType=item.replace(/\s/g, '')
    history(`/${UrlPath.portfolioTransaction}${transType}/0/${params.PortfolioId}/${3}`);
  };

  return (
    isHovered && (
      <div className="list-of-items" onMouseEnter={handleListMouseEnter} onMouseLeave={handleListMouseLeave}>
        {TransactionMenuList.map((item) => (
          <div
            key={item.DisplayName}
            onClick={() =>handleItemClick(item.DisplayName)}
            // className={item.IsVisible ? "" : "disabled-menu-item"}
          >
            {item.DisplayName}
          </div>
        ))}
      </div>
    )
  );
};

